module.exports = __webpack_public_path__ + "img/Thumbnail_ZWF_Brandon_Zuza.0911383c.jpg";